export const LIST_STYLE = { width: '100%', padding: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' };
export const MORE_RESULTS_BUTTON_STYLE = { width: '60%', borderRadius: '8px', margin: '20px 0' };
